// Dependencies
import ExternalAPI from '../utils/api';

// Config
import { baseURL, endpoints, authNonce } from '../utils/config';

// class WooptimaAPI extends ExternalAPI {
//     submitForm = async (data: {[key: string]: string|number|string[]}) => await this.request('submitForm', {data});
//     getFormSections = async () => await this.request('getFormSections');
//     getCitiesList = async () => await this.request('getCitiesList');
// }

class WooptimaAPI extends ExternalAPI {
	submitForm = async (data: { [key: string]: string | number | string[] }) => await this.request('submitForm', { data });
	getFormSections = async () => ({
		data: [
			{
				"name": "section-start",
				"type": "start",
				"groups": [
					{
						"name": "customerType",
						"label": "Som",
						"type": "radio",
						"tooltipLabel": "Podľa čoho určím svoj sektor?",
						"hasIcons": true,
						"options": [
							{
								"label": "Firma",
								"description": "Podnikateľ (fyzická alebo právnická osoba), ktorý je zapísaný v obchodnom registri, živnostenskom registri, alebo podniká na základe iného oprávnenia.",
								"value": "firma",
								"color": "#21B057"
							},
							{
								"label": "Developer",
								"description": "Developer je investor (fyzická alebo právnická osoba), ktorá investuje do výstavby nehnuteľností určených na predaj alebo prenájom.",
								"value": "developer",
								"color": "#21B057"
							},
							{
								"label": "Verejný sektor",
								"description": "Verejný sektor je špecifickou súčasťou ekonomiky, ktorá poskytuje verejné služby (nemocnice, školy, mestá a obce, ...)\\nSlužby vo verejnom sektore sú financované z verejných prostriedkov prostredníctvom daní.",
								"value": "verejny-sektor",
								"color": "#21B057"
							}
						]
					},
					{
						"name": "projectType",
						"label": "Môj projekt pozostáva z",
						"type": "checkbox",
						"options": [
							{
								"label": "Bytov",
								"value": "byt"
							},
							{
								"label": "Administratívy",
								"value": "administrativa"
							},
							{
								"label": "Polyfunkcie",
								"value": "polyfunckia"
							}
						],
						"conditions": [
							{
								"name": "customerType",
								"value": "developer",
								"operator": "=="
							}
						]
					},
					{
						"name": "projectLocation",
						"label": "Môj objekt sa nachádza v",
						"type": "dropdown",
						"autocomplete": true,
						"placeholder": "napr. Bratislava",
						"source": "getCitiesList",
						"options": [
							{
								"label": "Ábelová",
								"value": "Ábelová"
							},
							{
								"label": "Abovce",
								"value": "Abovce"
							},
							{
								"label": "Abrahám",
								"value": "Abrahám"
							},
							{
								"label": "Abrahámovce",
								"value": "Abrahámovce"
							},
							{
								"label": "Abrahámovce",
								"value": "Abrahámovce"
							},
							{
								"label": "Abramová",
								"value": "Abramová"
							},
							{
								"label": "Abranovce",
								"value": "Abranovce"
							},
							{
								"label": "Adamovské Kochanovce",
								"value": "Adamovské Kochanovce"
							},
							{
								"label": "Adidovce",
								"value": "Adidovce"
							},
							{
								"label": "Alekšince",
								"value": "Alekšince"
							}
						],
						"conditions": [
							{
								"name": "customerType",
								"value": "developer",
								"operator": "=="
							}
						]
					},
					{
						"name": "requestedServices",
						"label": "Mám záujem o",
						"type": "checkbox",
						"hasIcons": true,
						"options": [
							{
								"label": "Flexibilita spotreby",
								"value": "flexibilita-spotreby",
								"color": "#4364AE",
								"conditions": [
									{
										"name": "customerType",
										"value": "firma",
										"operator": "=="
									}
								]
							},
							{
								"label": "Teplo",
								"value": "teplo",
								"color": "#F35A91",
								"conditions": [
									{
										"name": "customerType",
										"value": "developer",
										"operator": "=="
									}
								]
							},
							{
								"label": "Chlad",
								"value": "chlad",
								"color": "#B0383E",
								"conditions": [
									{
										"name": "customerType",
										"value": "developer",
										"operator": "=="
									}
								]
							},
							{
								"label": "Teplo-chlad",
								"value": "teplo-chlad",
								"sections": [
									"section-6",
									"section-7",
									"section-8"
								],
								"color": "#B0383E",
								"conditions": [
									{
										"name": "customerType",
										"value": "firma",
										"operator": "=="
									}
								]
							},
							{
								"label": "Osvetlenie",
								"value": "osvetlenie",
								"sections": [
									"section-4",
									"section-5"
								],
								"color": "#EBB552",
								"conditions": [
									{
										"name": "customerType",
										"value": "firma",
										"operator": "=="
									},
									{
										"name": "customerType",
										"value": "verejny-sektor",
										"operator": "=="
									}
								]
							},
							{
								"label": "Fotovoltaika",
								"value": "fotovoltaika",
								"sections": [
									"section-3"
								],
								"color": "#E99179",
								"conditions": [
									{
										"name": "customerType",
										"value": "firma",
										"operator": "=="
									},
									{
										"name": "customerType",
										"value": "verejny-sektor",
										"operator": "=="
									}
								]
							},
							{
								"label": "Elektromobilita",
								"value": "elektromobilita",
								"sections": [
									"section-2"
								],
								"color": "#47BAB3",
								"conditions": [
									{
										"name": "customerType",
										"value": "firma",
										"operator": "=="
									},
									{
										"name": "customerType",
										"value": "verejny-sektor",
										"operator": "=="
									}
								]
							},
							{
								"label": "Elektrina",
								"value": "elektrina",
								"color": "#9C9278"
							},
							{
								"label": "Plyn",
								"value": "plyn",
								"color": "#AB509F",
								"conditions": [
									{
										"name": "customerType",
										"value": "domacnost",
										"operator": "!="
									}
								]
							},
							{
								"label": "Iné",
								"value": "ine",
								"color": "#21B057",
								"conditions": [
									{
										"name": "customerType",
										"value": "domacnost",
										"operator": "!="
									}
								]
							}
						]
					}
				]
			},
			{
				"name": "section-1",
				"label": "Teplo/Chlad",
				"color": "#B0383E",
				"hasDynamicLabel": true,
				"stepByStep": false,
				"conditions": [
					{
						"name": "customerType",
						"value": "developer",
						"operator": "=="
					}
				],
				"calculators": [
					{
						"name": "developerPowerSavings",
						"type": "simple",
						"fields": [
							"heatingPowerConsumption",
							"coolingPowerConsumption"
						],
						"variables": {
							"currency": "€"
						},
						"resultPrefixText": "Môžete ušetriť",
						"resultSuffixText": "až %(result)s %(currency)s",
						"resultNote": "Pozn.: Výška úspory je odhadovaná na základe zadaného výkonu. Konečná výška úspory je závislá od voľby technológie.",
						"rules": {
							"0-200": 100000,
							"201-400": 200000,
							"401-600": 270000,
							"601-1000": 450000,
							"1001+": 450000,
							"neviem": 0
						}
					}
				],
				"groups": [
					{
						"name": "heatingPowerConsumption",
						"label": "Veľkosť zdroja tepla je",
						"type": "radio",
						"options": [
							{
								"label": "0-200 kW",
								"value": "0-200"
							},
							{
								"label": "201-400 kW",
								"value": "201-400"
							},
							{
								"label": "401-600 kW",
								"value": "401-600"
							},
							{
								"label": "601-1000 kW",
								"value": "601-1000"
							},
							{
								"label": "1001 a viac kW",
								"value": "1001+"
							},
							{
								"label": "Neviem",
								"value": "neviem"
							}
						],
						"conditions": [
							{
								"name": "requestedServices",
								"value": "teplo",
								"operator": "IN"
							}
						]
					},
					{
						"name": "coolingPowerConsumption",
						"label": "Veľkosť zdroja chladu je",
						"type": "radio",
						"options": [
							{
								"label": "0-200 kW",
								"value": "0-200"
							},
							{
								"label": "201-400 kW",
								"value": "201-400"
							},
							{
								"label": "401-600 kW",
								"value": "401-600"
							},
							{
								"label": "601-1000 kW",
								"value": "601-1000"
							},
							{
								"label": "1001 a viac kW",
								"value": "1001+"
							},
							{
								"label": "Neviem",
								"value": "neviem"
							}
						],
						"conditions": [
							{
								"name": "requestedServices",
								"value": "chlad",
								"operator": "IN"
							}
						]
					}
				]
			},
			{
				"name": "section-2",
				"label": "Elektromobilita",
				"color": "#47BAB3",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "elektromobilita",
						"operator": "IN"
					}
				],
				"groups": [
					{
						"name": "chargingStationPlacement",
						"label": "Kde chcete mať umiestnenú vašu nabíjaciu stanicu?",
						"type": "dropdown",
						"options": [
							{
								"label": "Administratívna budova (dlhodobé parkovanie pre zamestnancov)",
								"value": "administrativna-budova-dlhodobe"
							},
							{
								"label": "Administratívna budova (krátkodobé parkovanie pre zamestnancov)",
								"value": "administrativna-budova-kratkodobe-parkovanie"
							},
							{
								"label": "Obytná rezidencia",
								"value": "obytna-rezidencia"
							},
							{
								"label": "Nákupné centrum",
								"value": "nakupne-centrum"
							},
							{
								"label": "Iné",
								"value": "ine"
							}
						]
					},
					{
						"name": "chargingStationCount",
						"label": "Koľko nabíjacích staníc potrebujete?",
						"type": "number"
					}
				]
			},
			{
				"name": "section-3",
				"label": "Fotovoltaika",
				"color": "#E99179",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "fotovoltaika",
						"operator": "IN"
					}
				],
				"calculators": [
					{
						"name": "photovoltaicsPowerSavings",
						"type": "advanced",
						"equation": "abs( ( ( ( %(reservedCapacityAmount)s * 0.6 ) ) / %(annualPowerConsumption)s ) * 100 )",
						"fields": [
							"reservedCapacityAmount",
							"annualPowerConsumption"
						],
						"variables": {
							"unit": "%"
						},
						"resultPrefixText": "Nová fotovoltika môže pokryť až",
						"resultSuffixText": "%(result)s %(unit)s celkovej spotrebovanej energie."
					}
				],
				"groups": [
					{
						"name": "reservedCapacityAmount",
						"label": "Veľkosť zazmluvnenej rezerovavanej kapacity",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "kW"
					},
					{
						"name": "annualPowerConsumption",
						"label": "Ročná spotreba firmy",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "mWh"
					}
				]
			},
			{
				"name": "section-4",
				"label": "Verejné osvetlenie",
				"color": "#EBB552",
				"conditions": [
					{
						"name": "customerType",
						"value": "verejny-sektor",
						"operator": "=="
					},
					{
						"name": "requestedServices",
						"value": "osvetlenie",
						"operator": "IN"
					}
				],
				"calculators": [
					{
						"name": "streetLightsPowerSavings",
						"type": "advanced",
						"equation": "(( (%(numOfLightningDevices)s * %(averageLightningDevicePower)s * %(nightHoursInYear)s / 1000) - ( (%(numOfLightningDevices)s * %(averageLightningDevicePower)s * %(nightHoursInYear)s / 1000) * 0.45 ) ) / (%(numOfLightningDevices)s * %(averageLightningDevicePower)s * %(nightHoursInYear)s / 1000)) * 100",
						"fields": [
							"numOfLightningDevices",
							"averageLightningDevicePower"
						],
						"variables": {
							"nightHoursInYear": 4000,
							"hoursInDay": 24,
							"averagePercentualSavings": 0.5,
							"initialPowerConsumptionReducement": 0.8,
							"unit": "%"
						},
						"resultPrefixText": "Vaša odhadovaná úspora energie je",
						"resultSuffixText": "%(result)s %(unit)s"
					}
				],
				"groups": [
					{
						"name": "annualElectricityConsumption",
						"label": "Ročná spotreba elektriny na VO podľa vyúčtovacích faktúr",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "kWh/rok"
					},
					{
						"name": "annualElectricityCosts",
						"label": "Celkové ročné náklady na elektrinu pre VO",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "€ s DPH"
					},
					{
						"name": "annualMaintenanceCosts",
						"label": "Celkové ročné náklady na správu a údržbu VO",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "€ s DPH"
					},
					{
						"name": "bindedToNFPProvision",
						"label": "Je na sústavu VO viazanosť z dôvodu poskytnutia NFP?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "numOfLightningDevices",
						"label": "Počet svietidiel",
						"type": "number",
						"min": 0,
						"max": 1000000000
					},
					{
						"name": "averageLightningDevicePower",
						"label": "Priemerný výkon svietidla",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "W"
					},
					{
						"name": "numOfSwitchboards",
						"label": "Počet rozvádzačov VO",
						"type": "number",
						"min": 0,
						"max": 1000000000
					},
					{
						"name": "lightningControlUsed",
						"label": "Je použitá regulácia verejného osvetlenia?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "additionalDecorationsConnected",
						"label": "Je na sústavu VO napojená vianočná výzdoba, osvetlenie pamiatky a pod.?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "lightsOnAllNight",
						"label": "Svieti VO celú noc?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "lightsOffTimeRange",
						"label": "VO je vypnuté v čase od - do",
						"placeholder": "napr. 20:00 - 06:00",
						"type": "timerange",
						"conditions": [
							{
								"name": "lightsOnAllNight",
								"value": "false",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-5",
				"label": "Firemné osvetlenie",
				"color": "#EBB552",
				"conditions": [
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "requestedServices",
						"value": "osvetlenie",
						"operator": "IN"
					}
				],
				"calculators": [
					{
						"name": "companyLightsPowerSavings",
						"type": "advanced",
						"equation": "abs( ( ( ( %(numOfCompanyLightningDevices)s * %(averageCompanyLightningDevicePower)s * %(weeklyLightningHours)s * 0.5 * 0.8 ) - ( %(numOfCompanyLightningDevices)s * %(averageCompanyLightningDevicePower)s * %(weeklyLightningHours)s ) ) / ( %(numOfCompanyLightningDevices)s * %(averageCompanyLightningDevicePower)s * %(weeklyLightningHours)s ) ) * 100)",
						"fields": [
							"numOfCompanyLightningDevices",
							"averageCompanyLightningDevicePower",
							"weeklyLightningHours"
						],
						"variables": {
							"unit": "%"
						},
						"resultPrefixText": "Vaša odhadovaná úspora energie je",
						"resultSuffixText": "%(result)s %(unit)s"
					}
				],
				"groups": [
					{
						"name": "ledTechnologyInstalled",
						"label": "Máte vo vašej spoločnosti inštalovanú LED technológiu?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "numOfCompanyLightningDevices",
						"label": "Počet svietidiel",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"conditions": [
							{
								"name": "ledTechnologyInstalled",
								"value": "false",
								"operator": "=="
							}
						]
					},
					{
						"name": "averageCompanyLightningDevicePower",
						"label": "Priemerný výkon",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "W",
						"conditions": [
							{
								"name": "ledTechnologyInstalled",
								"value": "false",
								"operator": "=="
							}
						]
					},
					{
						"name": "weeklyLightningHours",
						"label": "Počet hodín svietenia na týždeň",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "hodín",
						"conditions": [
							{
								"name": "ledTechnologyInstalled",
								"value": "false",
								"operator": "=="
							}
						]
					},
					{
						"name": "mostLightningTechnology",
						"label": "Prevažujúca technológia svietidiel",
						"type": "text",
						"conditions": [
							{
								"name": "ledTechnologyInstalled",
								"value": "false",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-9",
				"label": "Flexibilita spotreby",
				"color": "#4364AE",
				"download": {
					"label": "Stiahnuť prezentáciu",
					"type": "pdf",
					"url": "/wp-content/plugins/es-forms/assets/documents/es-flexibilita-spotreby-prezentacia.pdf"
				},
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					}
				],
				"calculators": [
					{
						"name": "consumptionFlexibility",
						"type": "simple",
						"variables": {
							"amount": "13 000",
							"unit": "€"
						},
						"fields": [],
						"resultNote": "Ak je celkový elektrický výkon dostupný pre reguláciu 500 kW, tak môžete ušetriť až %(amount)s %(unit)s ročne."
					}
				],
				"groups": [
					{
						"name": "alreadyBuyingElectricityFromSEES",
						"label": "Ste už zákazníkom a odberateľom elektriny od SEES?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "anySystemsInYourCompany",
						"label": "Máte zavedený niektorý z týchto systémov vo vašej spoločnosti?",
						"type": "checkbox",
						"options": [
							{
								"label": "Čerpadlá",
								"value": "cerpadla"
							},
							{
								"label": "Kompresory",
								"value": "kompresory"
							},
							{
								"label": "Mlyny (kameň)",
								"value": "mlyny"
							},
							{
								"label": "Dopravníky",
								"value": "dopravniky"
							},
							{
								"label": "Motory s frekvenčným meničom",
								"value": "motory-s-frekvencnym-menicom"
							},
							{
								"label": "Tepelné čerpadlá",
								"value": "tepelne-cerpadla"
							},
							{
								"label": "Klimatizácie",
								"value": "klimatizacie"
							},
							{
								"label": "Chladiace systémy",
								"value": "chladiace-systemy"
							},
							{
								"label": "Elektrické pece",
								"value": "elektricke-pece"
							}
						]
					}
				]
			},
			{
				"name": "section-cerpadla",
				"label": "Čerpadlá",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "cerpadla",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "cerpadlaAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "cerpadlaMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "cerpadlaAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-kompresory",
				"label": "Kompresory",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "kompresory",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "kompresoryAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "kompresoryMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "kompresoryAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-mlyny",
				"label": "Mlyny",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "mlyny",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "mlynyAlreadyInstalledMaR",
						"autoScroll": false,
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "mlynyMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "mlynyAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-dopravniky",
				"label": "Dopravníky",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "dopravniky",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "dopravnikyAlreadyInstalledMaR",
						"autoScroll": false,
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "dopravnikyMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "dopravnikyAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-motory-s-frekvencnym-menicom-",
				"label": "Motory s frekvenčným meničom",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "motory-s-frekvencnym-menicom",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "motorySFrekvencymMenicomAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "motorySFrekvencymMenicomMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "motorySFrekvencymMenicomAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-tepelne-cerpadla",
				"label": "Tepelné čerpadlá",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "tepelne-cerpadla",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "tepelneCerpadlaAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "tepelneCerpadlaMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "tepelneCerpadlaAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-klimatizacie",
				"label": "Klimatizácie",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "klimatizacie",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "klimatizacieAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "klimatizacieMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "klimatizacieAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-chladiacie-systemy",
				"label": "Chladiace systémy",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "chladiace-systemy",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "chladiaceSystemyAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "chladiaceSystemyMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "chladiaceSystemyAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-elektricke-pece",
				"label": "Elektrické pece",
				"textColor": "#4364AE",
				"color": "#EBF2FF",
				"conditions": [
					{
						"name": "requestedServices",
						"value": "flexibilita-spotreby",
						"operator": "IN"
					},
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "anySystemsInYourCompany",
						"value": "elektricke-pece",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "elektrickePeceAlreadyInstalledMaR",
						"label": "Máte už nainštalovaný systém Merania a regulácie (MaR)?",
						"autoScroll": false,
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "elektrickePeceMaRSystemInstalledName",
						"label": "Ktorý systém Merania a regulácií (MaR) máte nainštalovaný?",
						"autoScroll": false,
						"type": "dropdown",
						"options": [
							{
								"label": "Siemens",
								"value": "siemens"
							},
							{
								"label": "Sauter",
								"value": "sauter"
							},
							{
								"label": "Honeywell",
								"value": "honeywell"
							},
							{
								"label": "Iný",
								"value": "iny"
							}
						],
						"conditions": [
							{
								"name": "elektrickePeceAlreadyInstalledMaR",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-10",
				"label": "Teplo/Chlad",
				"color": "#b0383e",
				"conditions": [
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "requestedServices",
						"value": "teplo-chlad",
						"operator": "IN"
					}
				],
				"groups": [
					{
						"name": "requestedSubServices",
						"label": "Konkrétne o",
						"type": "checkbox",
						"options": [
							{
								"label": "Výroba a distrubúcia tepla",
								"value": "teplo"
							},
							{
								"label": "Výroba a distrubúcia chladu",
								"value": "chlad"
							},
							{
								"label": "Rekuperácia odpadového tepla",
								"value": "rekuperacia"
							}
						]
					}
				]
			},
			{
				"name": "section-6",
				"label": "Teplo",
				"color": "#F35A91",
				"conditions": [
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "requestedServices",
						"value": "teplo-chlad",
						"operator": "IN"
					},
					{
						"name": "requestedSubServices",
						"value": "teplo",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "currentHeatingSourceObsolete",
						"label": "Je váš zdroj tepla zastaralý, neefektívny alebo často poruchový?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "currentHeatingSourceType",
						"label": "Aký máte momentálne zdroj tepla?",
						"type": "checkbox",
						"options": [
							{
								"label": "Plynová kotoľna",
								"value": "plynova-kotolna"
							},
							{
								"label": "Tepelné čerpadlo",
								"value": "tepelne-cerpadlo"
							},
							{
								"label": "Odpadové teplo z výroby",
								"value": "odpadové-teplo-z-vyroby"
							},
							{
								"label": "Centrálne zásobovanie tepla",
								"value": "centralne-zasobovanie-tepla"
							},
							{
								"label": "Iné",
								"value": "ine"
							}
						]
					},
					{
						"name": "heatingSourcePower",
						"label": "Výkon vášho zdroja tepla je",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "kW"
					},
					{
						"name": "heatingSourceAge",
						"label": "Vek vášho zdroja tepla je",
						"type": "number",
						"min": 0,
						"max": 100,
						"suffix": "rokov"
					}
				]
			},
			{
				"name": "section-7",
				"label": "Chlad",
				"color": "#B0383E",
				"conditions": [
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "requestedServices",
						"value": "teplo-chlad",
						"operator": "IN"
					},
					{
						"name": "requestedSubServices",
						"value": "chlad",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "currentCoolingSourceObsolete",
						"label": "Je váš zdroj chladu zastaralý, neefektívny alebo často poruchový?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "currentCoolingSourceType",
						"label": "Aký máte momentálne zdroj chladu?",
						"type": "checkbox",
						"options": [
							{
								"label": "Chiller",
								"value": "chiller"
							},
							{
								"label": "Tepelné čerpadlo",
								"value": "tepelne-cerpadlo"
							},
							{
								"label": "Absorpčné chladiče",
								"value": "absorpcne-chladice"
							},
							{
								"label": "Iné",
								"value": "ine"
							}
						]
					},
					{
						"name": "coolingSourcePower",
						"label": "Výkon vášho zdroja chladu je",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "kW"
					},
					{
						"name": "coolingSourceAge",
						"label": "Vek vášho zdroja chladu je",
						"type": "number",
						"min": 0,
						"max": 100,
						"suffix": "rokov"
					}
				]
			},
			{
				"name": "section-8",
				"label": "Rekuperácia tepla",
				"color": "#DF2568",
				"conditions": [
					{
						"name": "customerType",
						"value": "firma",
						"operator": "=="
					},
					{
						"name": "requestedSubServices",
						"value": "rekuperacia",
						"operator": "IN"
					},
					{
						"name": "requestedServices",
						"value": "teplo-chlad",
						"operator": "IN"
					}
				],
				"calculators": [],
				"groups": [
					{
						"name": "recuperatioAnnualElectricityConsumption",
						"label": "Aká je vaša ročná spotreby elektriny",
						"type": "number",
						"suffix": "MWh"
					},
					{
						"name": "anyHeatLossDuringProductionProcess",
						"label": "Máte odpadové teplo v procese výroby?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						]
					},
					{
						"name": "heatLossMinEightyCelsius",
						"label": "Máte minimálnu teplotu odpadového tepla aspoň 80°C?",
						"type": "radio",
						"options": [
							{
								"label": "Áno",
								"value": "true"
							},
							{
								"label": "Nie",
								"value": "false"
							}
						],
						"conditions": [
							{
								"name": "anyHeatLossDuringProductionProcess",
								"value": "true",
								"operator": "=="
							}
						]
					},
					{
						"name": "potentialHeatLossPower",
						"label": "Viete povedať približný výkon odpadového tepla?",
						"type": "number",
						"min": 0,
						"max": 1000000000,
						"suffix": "kW",
						"conditions": [
							{
								"name": "anyHeatLossDuringProductionProcess",
								"value": "true",
								"operator": "=="
							}
						]
					}
				]
			},
			{
				"name": "section-submit",
				"type": "submit",
				"heading": "Zadajte Váš e-mail alebo tel. číslo a my sa Vám ozveme",
				"subheading": "Prípadne nás kontaktujte priamo",
				"groups": [
					{
						"label": "E-mail",
						"name": "contactEmail",
						"type": "email"
					},
					{
						"label": "Tel. číslo",
						"name": "contactTel",
						"defaultValue": "+4219",
						"type": "tel"
					}
				]
			}
		]
	});
	getCitiesList = async () => ({
		data: [
			"Ábelová",
			"Abovce",
			"Abrahám",
			"Abrahámovce",
			"Abramová",
			"Abranovce",
			"Adamovské Kochanovce",
			"Adidovce",
			"Alekšince",
			"Andovce",
			"Andrejová",
			"Ardanovce",
			"Ardovo",
			"Arnutovce",
			"Babie",
			"Babiná",
			"Babindol",
			"Babinec",
			"Babín",
			"Bacúch",
			"Bacúrov",
			"Bačka",
			"Bačkov",
			"Bačkovík",
			"Badín",
			"Baďan",
			"Bajany",
			"Bajč",
			"Bajerov",
			"Bajerovce",
			"Bajka",
			"Bajtava",
			"Baka",
			"Baláže",
			"Baldovce",
			"Balog nad Ipľom",
			"Baloň",
			"Banka",
			"Banská Belá",
			"Banská Bystrica",
			"Banská Štiavnica",
			"Banské",
			"Banský Studenec",
			"Baňa",
			"Bara",
			"Barca",
			"Bardejov",
			"Bardoňovo",
			"Bartošova Lehôtka",
			"Bartošovce",
			"Baška",
			"Baškovce",
			"Bašovce",
			"Batizovce",
			"Báb",
			"Báč",
			"Bádice",
			"Báhoň",
			"Bánov",
			"Bánovce nad Bebravou",
			"Bánovce nad Ondavou",
			"Bátka",
			"Bátorová",
			"Bátorove Kosihy",
			"Bátovce",
			"Beckov",
			"Beharovce",
			"Becherov",
			"Belá",
			"Belá-Dulice",
			"Belá nad Cirochou",
			"Beladice",
			"Belejovce",
			"Belín",
			"Belina",
			"Belince",
			"Bellova Ves",
			"Beloveža",
			"Beluj",
			"Beluša",
			"Belža",
			"Beniakovce",
			"Benice",
			"Benkovce",
			"Beňadiková",
			"Beňadikovce",
			"Beňadovo",
			"Beňatina",
			"Beňuš",
			"Bernolákovo",
			"Bertotovce",
			"Beša",
			"Bešeňov",
			"Bešeňová",
			"Betlanovce",
			"Betliar",
			"Bežovce",
			"Bidovce",
			"Biel",
			"Bielovce",
			"Biely Kostol",
			"Bijacovce",
			"Biskupice",
			"Biskupová",
			"Bitarová",
			"Bílkove Humence",
			"Bíňa",
			"Bíňovce",
			"Blahová",
			"Blatná na Ostrove",
			"Blatná Polianka",
			"Blatné",
			"Blatné Remety",
			"Blatné Revištia",
			"Blatnica",
			"Blažice",
			"Blažovce",
			"Blesovce",
			"Blhovce",
			"Bobot",
			"Bobrov",
			"Bobrovček",
			"Bobrovec",
			"Bobrovník",
			"Bočiar",
			"Bodíky",
			"Bodiná",
			"Bodorová",
			"Bodovce",
			"Bodružal",
			"Bodza",
			"Bodzianske Lúky",
			"Bogliarka",
			"Bohdanovce",
			"Bohdanovce nad Trnavou",
			"Boheľov",
			"Bohunice",
			"Bohúňovo",
			"Bojná",
			"Bojnice",
			"Bojničky",
			"Boldog",
			"Boleráz",
			"Bolešov",
			"Boliarov",
			"Boľ",
			"Boľkovce",
			"Borcová",
			"Borčany",
			"Borčice",
			"Borinka",
			"Borová",
			"Borovce",
			"Borský Mikuláš",
			"Borský Svätý Jur",
			"Borša",
			"Bory",
			"Bošáca",
			"Bošany",
			"Bottovo",
			"Boťany",
			"Bôrka",
			"Bracovce",
			"Branč",
			"Branovo",
			"Bratislava",
			"Braväcovo",
			"Brdárka",
			"Brehov",
			"Brehy",
			"Brekov",
			"Brestov",
			"Brestov nad Laborcom",
			"Brestovany",
			"Brestovec",
			"Bretejovce",
			"Bretka",
			"Breza",
			"Brezany",
			"Brezina",
			"Breziny",
			"Breznica",
			"Breznička",
			"Brezno",
			"Brezolupy",
			"Brezov",
			"Brezová pod Bradlom",
			"Brezovec",
			"Brezovica",
			"Brezovička",
			"Brezovka",
			"Brežany",
			"Brhlovce",
			"Brieštie",
			"Brodské",
			"Brodzany",
			"Brunovce",
			"Brusnica",
			"Brusník",
			"Brusno",
			"Brutovce",
			"Bruty",
			"Brvnište",
			"Brzotín",
			"Buclovany",
			"Bučany",
			"Budča",
			"Budikovany",
			"Budimír",
			"Budiná",
			"Budince",
			"Budiš",
			"Budkovce",
			"Budmerice",
			"Buglovce",
			"Buková",
			"Bukovce",
			"Bukovec",
			"Bukovina",
			"Bulhary",
			"Bunetice",
			"Bunkovce",
			"Bušince",
			"Bušovce",
			"Buzica",
			"Buzitka",
			"Búč",
			"Bystrá",
			"Bystrany",
			"Bystré",
			"Bystričany",
			"Bystrička",
			"Byšta",
			"Bytča",
			"Bzenica",
			"Bzenov",
			"Bzince pod Javorinou",
			"Bziny",
			"Bzovík",
			"Bzovská Lehôtka",
			"Bžany",
			"Cabaj-Čápor",
			"Cabov",
			"Cakov",
			"Cejkov",
			"Cernina",
			"Cerová",
			"Cerovo",
			"Cestice",
			"Cigeľ",
			"Cigeľka",
			"Cigla",
			"Cimenná",
			"Cinobaňa",
			"Cífer",
			"Čab",
			"Čabalovce",
			"Čabiny",
			"Čabradský Vrbovok",
			"Čadca",
			"Čachtice",
			"Čajkov",
			"Čaka",
			"Čakajovce",
			"Čakanovce",
			"Čakany",
			"Čaklov",
			"Čalovec",
			"Čamovce",
			"Čaňa",
			"Čaradice",
			"Častá",
			"Častkov",
			"Častkovce",
			"Čata",
			"Čataj",
			"Čavoj",
			"Čáry",
			"Čebovce",
			"Čečehov",
			"Čečejovce",
			"Čechy",
			"Čechynce",
			"Čekovce",
			"Čeláre",
			"Čelkova Lehota",
			"Čelovce",
			"Čeľadice",
			"Čeľadince",
			"Čeľovce",
			"Čenkovce",
			"Čerenčany",
			"Čereňany",
			"Čerhov",
			"Čerín",
			"Čermany",
			"Černík",
			"Černina",
			"Černochov",
			"Čertižné",
			"Červená Voda",
			"Červenica",
			"Červenica pri Sabinove",
			"Červeník",
			"Červený Hrádok",
			"Červený Kameň",
			"Červený Kláštor",
			"Červeňany",
			"České Brezovo",
			"Čičarovce",
			"Čičava",
			"Čičmany",
			"Čierna",
			"Čierna Lehota",
			"Čierna nad Tisou",
			"Čierna Voda",
			"Čierne",
			"Čierne Kľačany",
			"Čierne nad Topľou",
			"Čierne Pole",
			"Čierny Balog",
			"Čierny Brod",
			"Čierny Potok",
			"Čifáre",
			"Čiližská Radvaň",
			"Čimhová",
			"Čirč",
			"Čižatice",
			"Číčov",
			"Číž",
			"Čoltovo",
			"Čremošné",
			"Čučma",
			"Čukalovce",
			"Dačov Lom",
			"Daletice",
			"Danišovce",
			"Dargov",
			"Davidov",
			"Debraď",
			"Dedačov",
			"Dedina Mládeže",
			"Dedinka",
			"Dedinky",
			"Dechtice",
			"Dekýš",
			"Demandice",
			"Demänovská Dolina",
			"Demjata",
			"Detrík",
			"Detva",
			"Detvianska Huta",
			"Devičany",
			"Devičie",
			"Dežerice",
			"Diaková",
			"Diakovce",
			"Diviacka Nová Ves",
			"Diviaky nad Nitricou",
			"Divín",
			"Divina",
			"Divinka",
			"Dlhá",
			"Dlhá nad Kysucou",
			"Dlhá nad Oravou",
			"Dlhá nad Váhom",
			"Dlhá Ves",
			"Dlhé Klčovo",
			"Dlhé nad Cirochou",
			"Dlhé Pole",
			"Dlhé Stráže",
			"Dlhoňa",
			"Dlžín",
			"Dobrá",
			"Dobrá Niva",
			"Dobrá Voda",
			"Dobroč",
			"Dobrohošť",
			"Dobroslava",
			"Dobšiná",
			"Dohňany",
			"Dojč",
			"Dolinka",
			"Dolná Breznica",
			"Dolná Krupá",
			"Dolná Lehota",
			"Dolná Mariková",
			"Dolná Mičiná",
			"Dolná Poruba",
			"Dolná Seč",
			"Dolná Streda",
			"Dolná Strehová",
			"Dolná Súča",
			"Dolná Tižina",
			"Dolná Trnávka",
			"Dolná Ves",
			"Dolná Ždaňa",
			"Dolné Dubové",
			"Dolné Kočkovce",
			"Dolné Lefantovce",
			"Dolné Lovčice",
			"Dolné Mladonice",
			"Dolné Naštice",
			"Dolné Obdokovce",
			"Dolné Orešany",
			"Dolné Otrokovce",
			"Dolné Plachtince",
			"Dolné Saliby",
			"Dolné Semerovce",
			"Dolné Srnie",
			"Dolné Strháre",
			"Dolné Trhovište",
			"Dolné Vestenice",
			"Dolné Zahorany",
			"Dolné Zelenice",
			"Dolný Badín",
			"Dolný Bar",
			"Dolný Harmanec",
			"Dolný Hričov",
			"Dolný Chotár",
			"Dolný Kalník",
			"Dolný Kubín",
			"Dolný Lieskov",
			"Dolný Lopašov",
			"Dolný Ohaj",
			"Dolný Pial",
			"Dolný Štál",
			"Dolný Vadičov",
			"Doľany",
			"Domadice",
			"Domaníky",
			"Domaniža",
			"Domaňovce",
			"Donovaly",
			"Drábsko",
			"Drahňov",
			"Drahovce",
			"Dravce",
			"Dražice",
			"Dražkovce",
			"Drážovce",
			"Drienčany",
			"Drienica",
			"Drienov",
			"Drienovec",
			"Drienovo",
			"Drienovská Nová Ves",
			"Drietoma",
			"Drnava",
			"Drňa",
			"Družstevná pri Hornáde",
			"Drženice",
			"Držkovce",
			"Dubinné",
			"Dubnica nad Váhom",
			"Dubnička",
			"Dubník",
			"Dubno",
			"Dubodiel",
			"Dubová",
			"Dubovany",
			"Dubovce",
			"Dubové",
			"Dubovec",
			"Dubovica",
			"Ducové",
			"Dudince",
			"Dukovce",
			"Dulov",
			"Dulova Ves",
			"Dulovce",
			"Dulovo",
			"Dunajská Lužná",
			"Dunajov",
			"Dunajská Streda",
			"Dunajský Klátov",
			"Duplín",
			"Dúbrava",
			"Dúbravica",
			"Dúbravka",
			"Dúbravy",
			"Dvorany nad Nitrou",
			"Dvorec",
			"Dvorianky",
			"Dvorníky",
			"Dvorníky-Včeláre",
			"Dvory nad Žitavou",
			"Ďačov",
			"Ďanová",
			"Ďapalovce",
			"Ďubákovo",
			"Ďurčiná",
			"Ďurďoš",
			"Ďurďošík",
			"Ďurďové",
			"Ďurkov",
			"Ďurková",
			"Ďurkovce",
			"Egreš",
			"Fačkov",
			"Falkušovce",
			"Farná",
			"Fekišovce",
			"Figa",
			"Fijaš",
			"Fiľakovo",
			"Fiľakovské Kováče",
			"Fintice",
			"Folkušová",
			"Forbasy",
			"Frička",
			"Fričkovce",
			"Fričovce",
			"Fulianka",
			"Gabčíkovo",
			"Gaboltov",
			"Gajary",
			"Galanta",
			"Galovany",
			"Gánovce",
			"Gáň",
			"Gbelce",
			"Gbely",
			"Gbeľany",
			"Geča",
			"Gelnica",
			"Gemer",
			"Gemerček",
			"Gemerská Hôrka",
			"Gemerská Panica",
			"Gemerská Poloma",
			"Gemerská Ves",
			"Gemerské Dechtáre",
			"Gemerské Michalovce",
			"Gemerské Teplice",
			"Gemerský Jablonec",
			"Gemerský Sad",
			"Geraltov",
			"Gerlachov",
			"Giglovce",
			"Giraltovce",
			"Girovce",
			"Glabušovce",
			"Gočaltovo",
			"Gočovo",
			"Golianovo",
			"Gortva",
			"Gôtovany",
			"Granč-Petrovce",
			"Gregorova Vieska",
			"Gregorovce",
			"Gribov",
			"Gruzovce",
			"Gyňov",
			"Habovka",
			"Habura",
			"Hačava",
			"Háj",
			"Hajná Nová Ves",
			"Hajnáčka",
			"Hájske",
			"Hajtovka",
			"Haláčovce",
			"Halič",
			"Haligovce",
			"Haluzice",
			"Hamuliakovo",
			"Handlová",
			"Hanigovce",
			"Haniska",
			"Hanková",
			"Hankovce",
			"Hanušovce nad Topľou",
			"Harakovce",
			"Harhaj",
			"Harichovce",
			"Harmanec",
			"Hatalov",
			"Hatné",
			"Havaj",
			"Havka",
			"Havranec",
			"Hažín",
			"Hažín nad Cirochou",
			"Hažlín",
			"Helcmanovce",
			"Heľpa",
			"Henckovce",
			"Henclová",
			"Hencovce",
			"Hendrichovce",
			"Herľany",
			"Hermanovce",
			"Hermanovce nad Topľou",
			"Hertník",
			"Hervartov",
			"Hiadeľ",
			"Hincovce",
			"Hladovka",
			"Hlboké",
			"Hlboké nad Váhom",
			"Hliník nad Hronom",
			"Hlinné",
			"Hlivištia",
			"Hlohovec",
			"Hniezdne",
			"Hnilčík",
			"Hnilec",
			"Hnojné",
			"Hnúšťa",
			"Hodejov",
			"Hodejovec",
			"Hodkovce",
			"Hodruša-Hámre",
			"Hokovce",
			"Holčíkovce",
			"Holiare",
			"Holice",
			"Holíč",
			"Holiša",
			"Holumnica",
			"Honce",
			"Hontianska Vrbica",
			"Hontianske Moravce",
			"Hontianske Nemce",
			"Hontianske Tesáre",
			"Hontianske Trsťany",
			"Horná Breznica",
			"Horná Kráľová",
			"Horná Krupá",
			"Horná Lehota",
			"Horná Mariková",
			"Horná Mičiná",
			"Horná Poruba",
			"Horná Potôň",
			"Horná Seč",
			"Horná Streda",
			"Horná Strehová",
			"Horná Súča",
			"Horná Štubňa",
			"Horná Ves",
			"Horná Ždaňa",
			"Horné Dubové",
			"Horné Hámre",
			"Horné Chlebany",
			"Horné Lefantovce",
			"Horné Mladonice",
			"Horné Mýto",
			"Horné Naštice",
			"Horné Obdokovce",
			"Horné Orešany",
			"Horné Otrokovce",
			"Horné Plachtince",
			"Horné Pršany",
			"Horné Saliby",
			"Horné Semerovce",
			"Horné Srnie",
			"Horné Strháre",
			"Horné Štitáre",
			"Horné Trhovište",
			"Horné Turovce",
			"Horné Vestenice",
			"Horné Zahorany",
			"Horné Zelenice",
			"Horný Badín",
			"Horný Bar",
			"Horný Hričov",
			"Horný Kalník",
			"Horný Lieskov",
			"Horný Pial",
			"Horný Tisovník",
			"Horný Vadičov",
			"Horňa",
			"Horňany",
			"Horovce",
			"Hoste",
			"Hostice",
			"Hostie",
			"Hostišovce",
			"Hostovice",
			"Hosťová",
			"Hosťovce",
			"Hozelec",
			"Hôrka",
			"Hôrka nad Váhom",
			"Hôrky",
			"Hrabičov",
			"Hrabkov",
			"Hrabová Roztoka",
			"Hrabovčík",
			"Hrabovec",
			"Hrabovec nad Laborcom",
			"Hrabovka",
			"Hrabské",
			"Hrabušice",
			"Hradisko",
			"Hradište",
			"Hradište pod Vrátnom",
			"Hrádok",
			"Hrachovište",
			"Hrachovo",
			"Hraničné",
			"Hranovnica",
			"Hraň",
			"Hrašné",
			"Hrašovík",
			"Hrčeľ",
			"Hrhov",
			"Hriadky",
			"Hričovské Podhradie",
			"Hriňová",
			"Hrišovce",
			"Hrkovce",
			"Hrlica",
			"Hrnčiarovce nad Parnou",
			"Hrnčiarska Ves",
			"Hrnčiarske Zalužany",
			"Hrochoť",
			"Hromoš",
			"Hronec",
			"Hronovce",
			"Hronsek",
			"Hronská Breznica",
			"Hronská Dúbrava",
			"Hronské Kľačany",
			"Hronské Kosihy",
			"Hronský Beňadik",
			"Hrubá Borša",
			"Hruboňovo",
			"Hrubov",
			"Hrubý Šúr",
			"Hrušov",
			"Hrušovany",
			"Hrušovo",
			"Hruštín",
			"Hubice",
			"Hubina",
			"Hubošovce",
			"Hubová",
			"Hubovo",
			"Hucín",
			"Hudcovce",
			"Hul",
			"Humenné",
			"Huncovce",
			"Hunkovce",
			"Hurbanova Ves",
			"Hurbanovo",
			"Husák",
			"Husiná",
			"Hutka",
			"Huty",
			"Hviezdoslavov",
			"Hvozdnica",
			"Hybe",
			"Hýľov",
			"Chanava",
			"Chlebnice",
			"Chlmec",
			"Chľaba",
			"Chmeľnica",
			"Chmeľov",
			"Chmeľová",
			"Chmeľovec",
			"Chminianska Nová Ves",
			"Chminianske Jakubovany",
			"Chmiňany",
			"Choča",
			"Chocholná-Velčice",
			"Choňkovce",
			"Chorvátsky Grob",
			"Chorváty",
			"Chotča",
			"Chotín",
			"Chrabrany",
			"Chrámec",
			"Chrastince",
			"Chrastné",
			"Chrasť nad Hornádom",
			"Chrenovec-Brusno",
			"Chropov",
			"Chrťany",
			"Chtelnica",
			"Chudá Lehota",
			"Chvalová",
			"Chvojnica",
			"Chynorany",
			"Chyžné",
			"Igram",
			"Ihľany",
			"Ihráč",
			"Ilava",
			"Iliašovce",
			"Ilija",
			"Imeľ",
			"Inovce",
			"Iňa",
			"Iňačovce",
			"Ipeľské Predmostie",
			"Ipeľské Úľany",
			"Ipeľský Sokolec",
			"Istebné",
			"Ivachnová",
			"Ivančiná",
			"Ivanice",
			"Ivanka pri Dunaji",
			"Ivanka pri Nitre",
			"Ivanovce",
			"Iža",
			"Ižipovce",
			"Ižkovce",
			"Jablonec",
			"Jablonica",
			"Jablonka",
			"Jablonov",
			"Jablonov nad Turňou",
			"Jablonové",
			"Jabloň",
			"Jabloňovce",
			"Jacovce",
			"Jahodná",
			"Jaklovce",
			"Jakovany",
			"Jakubany",
			"Jakubov",
			"Jakubova Voľa",
			"Jakubovany",
			"Jakušovce",
			"Jalová",
			"Jalovec",
			"Jalšové",
			"Jalšovík",
			"Jamník",
			"Janice",
			"Janík",
			"Janíky",
			"Jankovce",
			"Janov",
			"Janova Lehota",
			"Janovce",
			"Jánovce",
			"Janovík",
			"Jarabá",
			"Jarabina",
			"Jarok",
			"Jarovnice",
			"Jasenica",
			"Jasenie",
			"Jasenov",
			"Jasenová",
			"Jasenovce",
			"Jasenové",
			"Jasenovo",
			"Jaslovské Bohunice",
			"Jasov",
			"Jasová",
			"Jastrabá",
			"Jastrabie nad Topľou",
			"Jastrabie pri Michalovciach",
			"Jatov",
			"Jazernica",
			"Jedlinka",
			"Jedľové Kostoľany",
			"Jelenec",
			"Jelka",
			"Jelšava",
			"Jelšovce",
			"Jelšovec",
			"Jenkovce",
			"Jesenské",
			"Jestice",
			"Ješkova Ves",
			"Jezersko",
			"Jovice",
			"Jovsa",
			"Jur nad Hronom",
			"Jurkova Voľa",
			"Jurová",
			"Jurské",
			"Juskova Voľa",
			"Kačanov",
			"Kajal",
			"Kalameny",
			"Kalinkovo",
			"Kalinov",
			"Kalinovo",
			"Kalná nad Hronom",
			"Kalná Roztoka",
			"Kálnica",
			"Kalnište",
			"Kalonda",
			"Kalša",
			"Kaloša",
			"Kaluža",
			"Kaľamenová",
			"Kaľava",
			"Kamanová",
			"Kamenec pod Vtáčnikom",
			"Kamenica",
			"Kamenica nad Cirochou",
			"Kamenica nad Hronom",
			"Kameničany",
			"Kameničná",
			"Kamenín",
			"Kamenná Poruba",
			"Kamenné Kosihy",
			"Kamenný Most",
			"Kameňany",
			"Kamienka",
			"Kanianka",
			"Kapince",
			"Kapišová",
			"Kaplna",
			"Kapušany",
			"Kapušianske Kľačany",
			"Karlová",
			"Karná",
			"Kašov",
			"Kátlovce",
			"Kátov",
			"Kazimír",
			"Kecerovce",
			"Kecerovský Lipovec",
			"Kečkovce",
			"Kečovo",
			"Kechnec",
			"Kendice",
			"Kesovce",
			"Keť",
			"Kežmarok",
			"Kiarov",
			"Kladzany",
			"Klasov",
			"Kláštor pod Znievom",
			"Klátova Nová Ves",
			"Klčov",
			"Klenov",
			"Klenová",
			"Klenovec",
			"Kleňany",
			"Klieština",
			"Klin",
			"Klin nad Bodrogom",
			"Klížska Nemá",
			"Klokoč",
			"Klokočov",
			"Klubina",
			"Kluknava",
			"Kľačany",
			"Kľače",
			"Kľačno",
			"Kľak",
			"Kľúčovec",
			"Kľušov",
			"Kmeťovo",
			"Kobeliarovo",
			"Kobylnice",
			"Kobyly",
			"Koceľovce",
			"Kociha",
			"Kocurany",
			"Kočín-Lančár",
			"Kočovce",
			"Kochanovce",
			"Kojatice",
			"Kojšov",
			"Kokava nad Rimavicou",
			"Kokošovce",
			"Kokšov-Bakša",
			"Kolačkov",
			"Kolačno",
			"Koláre",
			"Kolárovice",
			"Kolárovo",
			"Kolbasov",
			"Kolbovce",
			"Kolibabovce",
			"Kolinovce",
			"Kolíňany",
			"Kolonica",
			"Kolta",
			"Komárany",
			"Komárno",
			"Komárov",
			"Komárovce",
			"Komjatice",
			"Komjatná",
			"Komoča",
			"Koniarovce",
			"Konrádovce",
			"Konská",
			"Koňuš",
			"Kopčany",
			"Kopernica",
			"Koplotovce",
			"Koprivnica",
			"Kordíky",
			"Korejovce",
			"Korňa",
			"Koromľa",
			"Korunková",
			"Korytárky",
			"Korytné",
			"Kosihovce",
			"Kosihy nad Ipľom",
			"Kosorín",
			"Kostolec",
			"Kostolište",
			"Kostolná pri Dunaji",
			"Kostolná Ves",
			"Kostolná-Záriečie",
			"Kostolné",
			"Kostolné Kračany",
			"Kostoľany nad Hornádom",
			"Kostoľany pod Tribečom",
			"Koš",
			"Košariská",
			"Košarovce",
			"Košeca",
			"Košecké Podhradie",
			"Košice",
			"Košická Belá",
			"Košická Polianka",
			"Košické Oľšany",
			"Košický Klečenov",
			"Koškovce",
			"Košolná",
			"Košúty",
			"Košťany nad Turcom",
			"Kotešová",
			"Kotmanová",
			"Kotrčiná Lúčka",
			"Kováčová",
			"Kováčovce",
			"Koválov",
			"Koválovec",
			"Kovarce",
			"Kozárovce",
			"Kozelník",
			"Kozí Vrbovok",
			"Kožany",
			"Kožuchov",
			"Kožuchovce",
			"Kračúnovce",
			"Krahule",
			"Krajná Bystrá",
			"Krajná Poľana",
			"Krajná Porúbka",
			"Krajné",
			"Krajné Čierno",
			"Krakovany",
			"Králiky",
			"Kráľ",
			"Kráľov Brod",
			"Kráľova Lehota",
			"Kráľová nad Váhom",
			"Kráľová pri Senci",
			"Kraľovany",
			"Kráľovce",
			"Kráľovce-Krnišov",
			"Kráľovičove Kračany",
			"Kráľovský Chlmec",
			"Kraskovo",
			"Krásna Lúka",
			"Krásna Ves",
			"Krásno",
			"Krásno nad Kysucou",
			"Krásnohorská Dlhá Lúka",
			"Krásnohorské Podhradie",
			"Krásnovce",
			"Krásny Brod",
			"Krasňany",
			"Kravany",
			"Kravany nad Dunajom",
			"Krčava",
			"Kremná",
			"Kremnica",
			"Kremnické Bane",
			"Kristy",
			"Krišľovce",
			"Krišovská Liesková",
			"Krivá",
			"Krivany",
			"Kriváň",
			"Krivé",
			"Krivoklát",
			"Krivosúd-Bodovka",
			"Kríže",
			"Krížová Ves",
			"Krížovany",
			"Križovany nad Dudváhom",
			"Krná",
			"Krnča",
			"Krokava",
			"Krompachy",
			"Krpeľany",
			"Krškany",
			"Krtovce",
			"Kručov",
			"Krupina",
			"Krušetnica",
			"Krušinec",
			"Krušovce",
			"Kružlov",
			"Kružlová",
			"Kružná",
			"Kružno",
			"Kšinná",
			"Kubáňovo",
			"Kučín",
			"Kuchyňa",
			"Kuklov",
			"Kuková",
			"Kukučínov",
			"Kunerad",
			"Kunešov",
			"Kunova Teplica",
			"Kuraľany",
			"Kurima",
			"Kurimany",
			"Kurimka",
			"Kurov",
			"Kusín",
			"Kútniky",
			"Kúty",
			"Kuzmice",
			"Kvačany",
			"Kvakovce",
			"Kvašov",
			"Kvetoslavov",
			"Kyjatice",
			"Kyjov",
			"Kynceľová",
			"Kysak",
			"Kyselica",
			"Kysta",
			"Kysucké Nové Mesto",
			"Kysucký Lieskovec",
			"Láb",
			"Lackov",
			"Lacková",
			"Lackovce",
			"Lada",
			"Ladce",
			"Ladice",
			"Ladmovce",
			"Ladomerská Vieska",
			"Ladomirov",
			"Ladomirová",
			"Ladzany",
			"Lakšárska Nová Ves",
			"Lascov",
			"Laskár",
			"Lastomír",
			"Lastovce",
			"Laškovce",
			"Látky",
			"Lazany",
			"Lazisko",
			"Lazy pod Makytou",
			"Lažany",
			"Lednica",
			"Lednické Rovne",
			"Legnava",
			"Lehnice",
			"Lehota",
			"Lehota nad Rimavicou",
			"Lehota pod Vtáčnikom",
			"Lehôtka",
			"Lehôtka pod Brehmi",
			"Lechnica",
			"Lekárovce",
			"Leles",
			"Leľa",
			"Lemešany",
			"Lenartov",
			"Lenartovce",
			"Lendak",
			"Lenka",
			"Lentvora",
			"Leopoldov",
			"Lesenice",
			"Lesíček",
			"Lesné",
			"Lesnica",
			"Leštiny",
			"Lešť (vojenský obvod)",
			"Letanovce",
			"Letničie",
			"Leváre",
			"Levice",
			"Levkuška",
			"Levoča",
			"Ležiachov",
			"Libichava",
			"Licince",
			"Ličartovce",
			"Liesek",
			"Lieskovany",
			"Lieskovec",
			"Liešno",
			"Liešťany",
			"Lietava",
			"Lietavská Lúčka",
			"Lietavská Svinná-Babkov",
			"Likavka",
			"Limbach",
			"Lipany",
			"Lipník",
			"Lipníky",
			"Lipová",
			"Lipovany",
			"Lipovce",
			"Lipové",
			"Lipovec",
			"Lipovník",
			"Liptovská Anna",
			"Liptovská Kokava",
			"Liptovská Lúžna",
			"Liptovská Osada",
			"Liptovská Porúbka",
			"Liptovská Sielnica",
			"Liptovská Štiavnica",
			"Liptovská Teplá",
			"Liptovská Teplička",
			"Liptovské Beharovce",
			"Liptovské Kľačany",
			"Liptovské Matiašovce",
			"Liptovské Revúce",
			"Liptovské Sliače",
			"Liptovský Hrádok",
			"Liptovský Ján",
			"Liptovský Michal",
			"Liptovský Mikuláš",
			"Liptovský Ondrej",
			"Liptovský Peter",
			"Liptovský Trnovec",
			"Lisková",
			"Lišov",
			"Litava",
			"Litmanová",
			"Livina",
			"Livinské Opatovce",
			"Livov",
			"Livovská Huta",
			"Lodno",
			"Lok",
			"Lokca",
			"Lom nad Rimavicou",
			"Lomná",
			"Lomné",
			"Lomnička",
			"Lontov",
			"Lopašov",
			"Lopúchov",
			"Lopušné Pažite",
			"Lošonec",
			"Lovce",
			"Lovča",
			"Lovčica-Trubín",
			"Lovinobaňa",
			"Lozorno",
			"Ložín",
			"Lubeník",
			"Lubina",
			"Lúč na Ostrove",
			"Lučatín",
			"Lučenec",
			"Lúčina",
			"Lučivná",
			"Lúčka",
			"Lúčky",
			"Lúčnica nad Žitavou",
			"Ludanice",
			"Ludrová",
			"Luhyňa",
			"Lúka",
			"Lukačovce",
			"Lukáčovce",
			"Lukavica",
			"Lukov",
			"Lukovištia",
			"Lúky",
			"Lula",
			"Lupoč",
			"Lutila",
			"Lutiše",
			"Lužany",
			"Lužany pri Topli",
			"Lužianky",
			"Lysá pod Makytou",
			"Lysica",
			"Ľubá",
			"Ľubeľa",
			"Ľubica",
			"Ľubietová",
			"Ľubiša",
			"Ľubochňa",
			"Ľuboreč",
			"Ľuboriečka",
			"Ľubotice",
			"Ľubotín",
			"Ľubovec",
			"Ľudovítová",
			"Ľutina",
			"Ľutov",
			"Macov",
			"Mad",
			"Madunice",
			"Magnezitovce",
			"Machulince",
			"Majcichov",
			"Majere",
			"Majerovce",
			"Makov",
			"Makovce",
			"Malá Čalomija",
			"Malá Čausa",
			"Malá Čierna",
			"Malá Domaša",
			"Malá Franková",
			"Malá Hradná",
			"Malá Ida",
			"Malá Lehota",
			"Malá Lodina",
			"Malá Mača",
			"Malá nad Hronom",
			"Malá Poľana",
			"Malá Tŕňa",
			"Malacky",
			"Malachov",
			"Málaš",
			"Malatiná",
			"Malatíny",
			"Malcov",
			"Malčice",
			"Malé Borové",
			"Malé Dvorníky",
			"Malé Chyndice",
			"Malé Hoste",
			"Malé Kosihy",
			"Malé Kozmálovce",
			"Malé Kršteňany",
			"Malé Lednice",
			"Malé Leváre",
			"Malé Ludince",
			"Malé Ozorovce",
			"Malé Raškovce",
			"Malé Ripňany",
			"Malé Straciny",
			"Malé Trakany",
			"Malé Uherce",
			"Malé Vozokany",
			"Malé Zálužie",
			"Malé Zlievce",
			"Málinec",
			"Malinová",
			"Malinovo",
			"Malužiná",
			"Malý Cetín",
			"Malý Čepčín",
			"Malý Horeš",
			"Malý Kamenec",
			"Malý Krtíš",
			"Malý Lapáš",
			"Malý Lipník",
			"Malý Slavkov",
			"Malý Slivník",
			"Malý Šariš",
			"Malženice",
			"Mankovce",
			"Maňa",
			"Marcelová",
			"Margecany",
			"Marhaň",
			"Marianka",
			"Markovce",
			"Markuška",
			"Markušovce",
			"Maršová-Rašov",
			"Martin",
			"Martin nad Žitavou",
			"Martinček",
			"Martinová",
			"Martovce",
			"Mašková",
			"Maškovce",
			"Matejovce nad Hornádom",
			"Matiaška",
			"Matiašovce",
			"Matovce",
			"Matúškovo",
			"Matysová",
			"Maťovské Vojkovce",
			"Medovarce",
			"Medvedie",
			"Medveďov",
			"Medzany",
			"Medzev",
			"Medzianky",
			"Medzibrod",
			"Medzibrodie nad Oravou",
			"Medzilaborce",
			"Melčice-Lieskové",
			"Melek",
			"Meliata",
			"Mengusovce",
			"Merašice",
			"Merník",
			"Mestečko",
			"Mestisko",
			"Mičakovce",
			"Mierovo",
			"Miezgovce",
			"Michajlov",
			"Michal na Ostrove",
			"Michal nad Žitavou",
			"Michalková",
			"Michalok",
			"Michalová",
			"Michalovce",
			"Michaľany",
			"Miklušovce",
			"Miková",
			"Mikulášová",
			"Mikušovce",
			"Milhosť",
			"Miloslavov",
			"Milpoš",
			"Miňovce",
			"Mirkovce",
			"Miroľa",
			"Mládzovo",
			"Mlynárovce",
			"Mlynčeky",
			"Mlynica",
			"Mlynky",
			"Mníchova Lehota",
			"Mníšek nad Hnilcom",
			"Mníšek nad Popradom",
			"Moča",
			"Močenok",
			"Močiar",
			"Modra",
			"Modra nad Cirochou",
			"Modrany",
			"Modrová",
			"Modrovka",
			"Modrý Kameň",
			"Mojmírovce",
			"Mojš",
			"Mojtín",
			"Mojzesovo",
			"Mokrá Lúka",
			"Mokrance",
			"Mokroluh",
			"Mokrý Háj",
			"Moldava nad Bodvou",
			"Moravany",
			"Moravany nad Váhom",
			"Moravské Lieskové",
			"Moravský Svätý Ján",
			"Most pri Bratislave",
			"Mostová",
			"Moškovec",
			"Mošovce",
			"Moštenica",
			"Mošurov",
			"Motešice",
			"Motyčky",
			"Môlča",
			"Mrázovce",
			"Mučín",
			"Mudroňovo",
			"Mudrovce",
			"Muľa",
			"Muráň",
			"Muránska Dlhá Lúka",
			"Muránska Huta",
			"Muránska Lehota",
			"Muránska Zdychava",
			"Mútne",
			"Mužla",
			"Myjava",
			"Myslina",
			"Mýtna",
			"Mýtne Ludany",
			"Mýto pod Ďumbierom",
			"Nacina Ves",
			"Nadlice",
			"Naháč",
			"Nálepkovo",
			"Námestovo",
			"Nána",
			"Nandraž",
			"Necpaly",
			"Nedanovce",
			"Nedašovce",
			"Neded",
			"Nededza",
			"Nedožery-Brezany",
			"Nechválova Polianka",
			"Nemce",
			"Nemcovce",
			"Nemčice",
			"Nemčiňany",
			"Nemecká",
			"Nemečky",
			"Nemešany",
			"Nemšová",
			"Nenince",
			"Neporadza",
			"Nesvady",
			"Nesluša",
			"Neverice",
			"Nevidzany",
			"Nevoľné",
			"Nezbudská Lúčka",
			"Nimnica",
			"Nitra",
			"Nitra nad Ipľom",
			"Nitrianska Blatnica",
			"Nitrianska Streda",
			"Nitrianske Hrnčiarovce",
			"Nitrianske Pravno",
			"Nitrianske Rudno",
			"Nitrianske Sučany",
			"Nitrica",
			"Nižná ",
			"Nižná",
			"Nižná Boca",
			"Nižná Hutka",
			"Nižná Jablonka",
			"Nižná Jedľová",
			"Nižná Kamenica",
			"Nižná Myšľa",
			"Nižná Olšava",
			"Nižná Pisaná",
			"Nižná Polianka",
			"Nižná Rybnica",
			"Nižná Sitnica",
			"Nižná Slaná",
			"Nižná Voľa",
			"Nižné Ladičkovce",
			"Nižné Nemecké",
			"Nižné Repaše",
			"Nižné Ružbachy",
			"Nižný Čaj",
			"Nižný Hrabovec",
			"Nižný Hrušov",
			"Nižný Klátov",
			"Nižný Komárnik",
			"Nižný Kručov",
			"Nižný Lánec",
			"Nižný Mirošov",
			"Nižný Orlík",
			"Nižný Skálnik",
			"Nižný Slavkov",
			"Nižný Tvarožec",
			"Nižný Žipov",
			"Nolčovo",
			"Norovce",
			"Nová Baňa",
			"Nová Bašta",
			"Nová Bošáca",
			"Nová Bystrica",
			"Nová Dedina",
			"Nová Dedinka",
			"Nová Dubnica",
			"Nová Kelča",
			"Nová Lehota",
			"Nová Lesná",
			"Nová Ľubovňa",
			"Nová Polhora",
			"Nová Polianka",
			"Nová Sedlica",
			"Nová Ves",
			"Nová Ves nad Váhom",
			"Nová Ves nad Žitavou",
			"Nová Vieska",
			"Nováčany",
			"Nováky",
			"Nové Hony",
			"Nové Mesto nad Váhom",
			"Nové Sady",
			"Nové Zámky",
			"Novosad",
			"Novoť",
			"Nový Ruskov",
			"Nový Salaš",
			"Nový Svet",
			"Nový Tekov",
			"Nový Život",
			"Nýrovce",
			"Ňagov",
			"Ňárad",
			"Obeckov",
			"Obid",
			"Obišovce",
			"Oborín",
			"Obručné",
			"Obyce",
			"Očkov",
			"Očová",
			"Odorín",
			"Ohrady",
			"Ohradzany",
			"Ochodnica",
			"Ochtiná",
			"Okoč",
			"Okoličná na Ostrove",
			"Okrúhle",
			"Okružná",
			"Olcnava",
			"Olejníkov",
			"Olešná",
			"Olováry",
			"Olšovany",
			"Oľdza",
			"Oľka",
			"Oľšavce",
			"Oľšavica",
			"Oľšavka",
			"Oľšinkov",
			"Oľšov",
			"Omastiná",
			"Omšenie",
			"Ondavka",
			"Ondavské Matiašovce",
			"Ondrašovce",
			"Ondrašová",
			"Ondrejovce",
			"Opátka",
			"Opatovce",
			"Opatovce nad Nitrou",
			"Opatovská Nová Ves",
			"Opava",
			"Opiná",
			"Opoj",
			"Oponice",
			"Oravce",
			"Orávka",
			"Oravská Jasenica",
			"Oravská Lesná",
			"Oravská Polhora",
			"Oravská Poruba",
			"Oravské Veselé",
			"Oravský Biely Potok",
			"Oravský Podzámok",
			"Ordzovany",
			"Orechová",
			"Orechová Potôň",
			"Oreské",
			"Orešany",
			"Orlov",
			"Orovnica",
			"Ortuťová",
			"Osádka",
			"Osadné",
			"Osikov",
			"Oslany",
			"Osrblie",
			"Ostrá Lúka",
			"Ostratice",
			"Ostrov",
			"Ostrovany",
			"Ostrý Grúň",
			"Osturňa",
			"Osuské",
			"Oščadnica",
			"Otrhánky",
			"Otročok",
			"Ovčiarsko",
			"Ovčie",
			"Ozdín",
			"Ožďany",
			"Pača",
			"Padáň",
			"Padarovce",
			"Pakostov",
			"Palárikovo",
			"Palín",
			"Palota",
			"Panické Dravce",
			"Paňa",
			"Paňovce",
			"Papín",
			"Papradno",
			"Parchovany",
			"Parihuzovce",
			"Párnica",
			"Partizánska Ľupča",
			"Partizánske",
			"Pastovce",
			"Pastuchov",
			"Pašková",
			"Paština Závada",
			"Pata",
			"Pataš",
			"Patince",
			"Pavčina Lehota",
			"Pavlice",
			"Pavlová",
			"Pavlova Ves",
			"Pavlovce",
			"Pavlovce nad Uhom",
			"Pavľany",
			"Pažiť",
			"Pčoliné",
			"Pečenice",
			"Pečeňady",
			"Pečeňany",
			"Pečovská Nová Ves",
			"Peder",
			"Perín-Chym",
			"Pernek",
			"Petkovce",
			"Petrikovce",
			"Petrová",
			"Petrova Lehota",
			"Petrova Ves",
			"Petrovany",
			"Petrovce",
			"Petrovce nad Laborcom",
			"Petrovice",
			"Petrovo",
			"Pezinok",
			"Piešťany",
			"Pichne",
			"Píla",
			"Pidžin",
			"Pinciná",
			"Pinkovce",
			"Piskorovce",
			"Pitelová",
			"Plášťovce",
			"Plavé Vozokany",
			"Plavecké Podhradie",
			"Plavecký Mikuláš",
			"Plavecký Peter",
			"Plavecký Štvrtok",
			"Plaveč",
			"Plavnica",
			"Plechotice",
			"Pleš",
			"Plešivec",
			"Plevník-Drienové",
			"Pliešovce",
			"Ploské",
			"Pobedim",
			"Počarová",
			"Počúvadlo",
			"Podbiel",
			"Podbranč",
			"Podbrezová",
			"Podhájska",
			"Podhorany",
			"Podhorie",
			"Podhoroď",
			"Podhradie",
			"Podhradík",
			"Podkonice",
			"Podkriváň",
			"Podkylava",
			"Podlužany",
			"Podolie",
			"Podolínec",
			"Podrečany",
			"Podskalie",
			"Podtureň",
			"Podvysoká",
			"Podzámčok",
			"Pohorelá",
			"Pohranice",
			"Pohronská Polhora",
			"Pohronský Bukovec",
			"Pohronský Ruskov",
			"Pochabany",
			"Pokryváč",
			"Poliakovce",
			"Polianka",
			"Polichno",
			"Polina",
			"Poloma",
			"Polomka",
			"Poltár",
			"Poluvsie",
			"Poľanovce",
			"Poľany",
			"Poľný Kesov",
			"Pongrácovce",
			"Poniky",
			"Poprad",
			"Poproč",
			"Popudinské Močidľany",
			"Poráč",
			"Poriadie",
			"Porostov",
			"Poruba",
			"Poruba pod Vihorlatom",
			"Porúbka",
			"Poša",
			"Potok",
			"Potoky",
			"Potôčky",
			"Potônske Lúky",
			"Potvorice",
			"Považany",
			"Považská Bystrica",
			"Povina",
			"Povoda",
			"Povrazník",
			"Pozba",
			"Pozdišovce",
			"Pôtor",
			"Praha",
			"Prakovce",
			"Prašice",
			"Prašník",
			"Pravenec",
			"Pravica",
			"Pravotice",
			"Práznovce",
			"Prečín",
			"Predajná",
			"Predmier",
			"Prenčov",
			"Preseľany",
			"Prestavlky",
			"Prešov",
			"Príbelce",
			"Pribeník",
			"Pribeta",
			"Pribiš",
			"Príbovce",
			"Pribylina",
			"Priechod",
			"Priekopa",
			"Priepasné",
			"Prietrž",
			"Prietržka",
			"Prievaly",
			"Prievidza",
			"Prihradzany",
			"Príkra",
			"Príslop",
			"Prituľany",
			"Proč",
			"Prochot",
			"Prosačov",
			"Prosiek",
			"Prša",
			"Pruské",
			"Prusy",
			"Pružina",
			"Pstriná",
			"Ptičie",
			"Ptrukša",
			"Pucov",
			"Púchov",
			"Pukanec",
			"Pusté Čemerné",
			"Pusté Pole",
			"Pusté Sady",
			"Pusté Úľany",
			"Pušovce",
			"Rabča",
			"Rabčice",
			"Rad",
			"Radatice",
			"Radava",
			"Radimov",
			"Radnovce",
			"Radobica",
			"Radoľa",
			"Radoma",
			"Radošina",
			"Radošovce",
			"Radôstka",
			"Radvanovce",
			"Radvaň nad Dunajom",
			"Radvaň nad Laborcom",
			"Radzovce",
			"Rafajovce",
			"Rajčany",
			"Rajec",
			"Rajecká Lesná",
			"Rajecké Teplice",
			"Rákoš",
			"Raková",
			"Rakovčík",
			"Rakovec nad Ondavou",
			"Rakovice",
			"Rakovnica",
			"Rakovo",
			"Rakša",
			"Rakúsy",
			"Rakytník",
			"Rankovce",
			"Rapovce",
			"Raslavice",
			"Rastislavice",
			"Rašice",
			"Ratka",
			"Ratková",
			"Ratkovce",
			"Ratkovo",
			"Ratkovská Lehota",
			"Ratkovská Suchá",
			"Ratkovské Bystré",
			"Ratnovce",
			"Ratvaj",
			"Ráztočno",
			"Ráztoka",
			"Ražňany",
			"Reca",
			"Regetovka",
			"Rejdová",
			"Reľov",
			"Remeniny",
			"Remetské Hámre",
			"Renčišov",
			"Repejov",
			"Repište",
			"Rešica",
			"Rešov",
			"Revúca",
			"Revúcka Lehota",
			"Riečka",
			"Richnava",
			"Richvald",
			"Rimavská Baňa",
			"Rimavská Seč",
			"Rimavská Sobota",
			"Rimavské Brezovo",
			"Rimavské Janovce",
			"Rimavské Zalužany",
			"Rišňovce",
			"Rohov",
			"Rohovce",
			"Rohožník",
			"Rochovce",
			"Rokycany",
			"Rokytov",
			"Rokytov pri Humennom",
			"Rokytovce",
			"Rosina",
			"Roškovce",
			"Roštár",
			"Rovensko",
			"Rovinka",
			"Rovné",
			"Rovňany",
			"Rozhanovce",
			"Rozložná",
			"Roztoky",
			"Rožkovany",
			"Rožňava",
			"Rožňavské Bystré",
			"Rúbaň",
			"Rudina",
			"Rudinka",
			"Rudinská",
			"Rudlov",
			"Rudná",
			"Rudnianska Lehota",
			"Rudník",
			"Rudno",
			"Rudno nad Hronom",
			"Rudňany",
			"Rumanová",
			"Rumince",
			"Runina",
			"Ruská",
			"Ruská Bystrá",
			"Ruská Kajňa",
			"Ruská Nová Ves",
			"Ruská Poruba",
			"Ruská Volová",
			"Ruská Voľa",
			"Ruská Voľa nad Popradom",
			"Ruskov",
			"Ruskovce",
			"Ruský Hrabovec",
			"Ruský Potok",
			"Ružiná",
			"Ružindol",
			"Ružomberok",
			"Rybany",
			"Rybky",
			"Rybník",
			"Rykynčice",
			"Sabinov",
			"Sačurov",
			"Sádočné",
			"Sady nad Torysou",
			"Salka",
			"Santovka",
			"Sap",
			"Sása",
			"Sasinkovo",
			"Sazdice",
			"Sebedín-Bečov",
			"Sebedražie",
			"Sebechleby",
			"Seč",
			"Sečianky",
			"Sečovce",
			"Sečovská Polianka",
			"Sedliacka Dubová",
			"Sedlice",
			"Sedliská",
			"Sedmerovec",
			"Sejkov",
			"Sekule",
			"Selce",
			"Selec",
			"Selice",
			"Seľany",
			"Semerovo",
			"Senec",
			"Seniakovce",
			"Senica",
			"Senné",
			"Senohrad",
			"Seňa",
			"Sereď",
			"Sielnica",
			"Sihelné",
			"Sihla",
			"Sikenica",
			"Sikenička",
			"Siladice",
			"Silica",
			"Silická Brezová",
			"Silická Jablonica",
			"Sirk",
			"Sirník",
			"Skačany",
			"Skalica",
			"Skalité",
			"Skalka nad Váhom",
			"Skároš",
			"Skerešovo",
			"Sklabiná",
			"Sklabinský Podzámok",
			"Sklabiňa",
			"Sklené",
			"Sklené Teplice",
			"Skrabské",
			"Skýcov",
			"Sládkovičovo",
			"Slančík",
			"Slanec",
			"Slanská Huta",
			"Slanské Nové Mesto",
			"Slaská",
			"Slatina",
			"Slatina nad Bebravou",
			"Slatinka nad Bebravou",
			"Slatinské Lazy",
			"Slatvina",
			"Slavec",
			"Slavkovce",
			"Slavnica",
			"Slavoška",
			"Slavošovce",
			"Slepčany",
			"Sliač",
			"Sliepkovce",
			"Slizké",
			"Slivník",
			"Slopná",
			"Slovany",
			"Slovenská Kajňa",
			"Slovenská Ľupča",
			"Slovenská Nová Ves",
			"Slovenská Ves",
			"Slovenská Volová",
			"Slovenské Ďarmoty",
			"Slovenské Kľačany",
			"Slovenské Krivé",
			"Slovenské Nové Mesto",
			"Slovenské Pravno",
			"Slovenský Grob",
			"Slovinky",
			"Sľažany",
			"Smilno",
			"Smižany",
			"Smolenice",
			"Smolinské",
			"Smolnícka Huta",
			"Smolník",
			"Smrdáky",
			"Smrečany",
			"Snakov",
			"Snežnica",
			"Snina",
			"Socovce",
			"Soblahov",
			"Soboš",
			"Sobotište",
			"Sobrance",
			"Sokolce",
			"Sokolovce",
			"Sokoľ",
			"Sokoľany",
			"Solčany",
			"Solčianky",
			"Sološnica",
			"Soľ",
			"Soľnička",
			"Soľník",
			"Somotor",
			"Sopkovce",
			"Spišská Belá",
			"Spišská Nová Ves",
			"Spišská Stará Ves",
			"Spišská Teplica",
			"Spišské Bystré",
			"Spišské Hanušovce",
			"Spišské Podhradie",
			"Spišské Tomášovce",
			"Spišské Vlachy",
			"Spišský Hrhov",
			"Spišský Hrušov",
			"Spišský Štiavnik",
			"Spišský Štvrtok",
			"Stakčín",
			"Stakčínska Roztoka",
			"Stanča",
			"Stankovany",
			"Stankovce",
			"Stará Bašta",
			"Stará Bystrica",
			"Stará Halič",
			"Stará Huta",
			"Stará Kremnička",
			"Stará Lehota",
			"Stará Lesná",
			"Stará Ľubovňa",
			"Stará Myjava",
			"Stará Turá",
			"Stará Voda",
			"Staré",
			"Staré Hory",
			"Starina",
			"Starý Hrádok",
			"Starý Tekov",
			"Staškov",
			"Staškovce",
			"Stebnícka Huta",
			"Stebník",
			"Stožok",
			"Stráne pod Tatrami",
			"Stránska",
			"Stránske",
			"Stráňany",
			"Stráňavy",
			"Stratená",
			"Stráža",
			"Strážne",
			"Strážske",
			"Strečno",
			"Streda nad Bodrogom",
			"Stredné Plachtince",
			"Strekov",
			"Strelníky",
			"Stretava",
			"Stretavka",
			"Streženice",
			"Strihovce",
			"Stročín",
			"Stropkov",
			"Studená",
			"Studenec",
			"Studienka",
			"Stuľany",
			"Stupava",
			"Stupné",
			"Sučany",
			"Sudince",
			"Súdovce",
			"Suchá Dolina",
			"Suchá Hora",
			"Suchá nad Parnou",
			"Sucháň",
			"Suché",
			"Suché Brezovo",
			"Suchohrad",
			"Sukov",
			"Sulín",
			"Súlovce",
			"Súľov-Hradná",
			"Sušany",
			"Sútor",
			"Svätá Mária",
			"Svätoplukovo",
			"Svätuš",
			"Svätuše",
			"Svätý Anton",
			"Svätý Jur",
			"Svätý Kríž",
			"Svätý Peter",
			"Svederník",
			"Sverepec",
			"Sveržov",
			"Svetlice",
			"Svidnička",
			"Svidník",
			"Svinia",
			"Svinica",
			"Svinice",
			"Svinná",
			"Svit",
			"Svodín",
			"Svrbice",
			"Svrčinovec",
			"Šahy",
			"Šajdíkove Humence",
			"Šalgovce",
			"Šalgočka",
			"Šalov",
			"Šaľa",
			"Šambron",
			"Šamorín",
			"Šamudovce",
			"Šandal",
			"Šarbov",
			"Šarišská Poruba",
			"Šarišská Trstená",
			"Šarišské Bohdanovce",
			"Šarišské Čierne",
			"Šarišské Dravce",
			"Šarišské Jastrabie",
			"Šarišské Michaľany",
			"Šarišské Sokolovce",
			"Šarišský Štiavnik",
			"Šarkan",
			"Šarovce",
			"Šašová",
			"Šaštín-Stráže",
			"Šávoľ",
			"Šelpice",
			"Šemetkovce",
			"Šemša",
			"Šenkvice",
			"Šiatorská Bukovinka",
			"Šiba",
			"Šíd",
			"Šimonovce",
			"Šindliar",
			"Šintava",
			"Šípkov",
			"Šípkové",
			"Širákov",
			"Širkovce",
			"Široké",
			"Šišov",
			"Šivetice",
			"Šmigovec",
			"Šoltýska",
			"Šoporňa",
			"Špačince",
			"Špania Dolina",
			"Španie Pole",
			"Šrobárová",
			"Štefanov",
			"Štefanov nad Oravou",
			"Štefanová",
			"Štefanovce",
			"Štefanovičová",
			"Štefurov",
			"Šterusy",
			"Štiavnické Bane",
			"Štiavnička",
			"Štiavnik",
			"Štitáre",
			"Štítnik",
			"Štós",
			"Štôla",
			"Štrba",
			"Štrkovec",
			"Štúrovo",
			"Štvrtok",
			"Štvrtok na Ostrove",
			"Šuja",
			"Šuľa",
			"Šumiac",
			"Šuňava",
			"Šurany",
			"Šurianky",
			"Šurice",
			"Šúrovce",
			"Šútovo",
			"Šútovce",
			"Švábovce",
			"Švedlár",
			"Švošov",
			"Tachty",
			"Tajná",
			"Tajov",
			"Tarnov",
			"Tatranská Javorina",
			"Tašuľa",
			"Tehla",
			"Tekolďany",
			"Tekovská Breznica",
			"Tekovské Lužany",
			"Tekovské Nemce",
			"Tekovský Hrádok",
			"Telgárt",
			"Telince",
			"Temeš",
			"Teplička",
			"Teplička nad Váhom",
			"Tepličky",
			"Teplý Vrch",
			"Terany",
			"Terchová",
			"Teriakovce",
			"Terňa",
			"Tesáre",
			"Tesárske Mlyňany",
			"Tešedíkovo",
			"Tibava",
			"Tichý Potok",
			"Timoradza",
			"Tisinec",
			"Tisovec",
			"Tlmače",
			"Točnica",
			"Tokajík",
			"Tomášikovo",
			"Tomášov",
			"Tomášovce",
			"Topoľa",
			"Topoľčany",
			"Topoľčianky",
			"Topoľnica",
			"Topoľníky",
			"Topoľovka",
			"Toporec",
			"Tornaľa",
			"Torysa",
			"Torysky",
			"Tovarné",
			"Tovarnianska Polianka",
			"Tovarníky",
			"Tôň",
			"Trakovice",
			"Trávnica",
			"Trávnik",
			"Trebatice",
			"Trebejov",
			"Trebeľovce",
			"Trebichava",
			"Trebišov",
			"Trebostovo",
			"Trebušovce",
			"Trenč",
			"Trenčianska Teplá",
			"Trenčianska Turná",
			"Trenčianske Bohuslavice",
			"Trenčianske Jastrabie",
			"Trenčianske Mitice",
			"Trenčianske Stankovce",
			"Trenčianske Teplice",
			"Trenčín",
			"Trhová Hradská",
			"Trhovište",
			"Trnava",
			"Trnavá Hora",
			"Trnava pri Laborci",
			"Trnávka",
			"Trnkov",
			"Trnovec",
			"Trnovec nad Váhom",
			"Trnovo",
			"Tročany",
			"Trpín",
			"Trstená",
			"Trstená na Ostrove",
			"Trstené",
			"Trstené pri Hornáde",
			"Trstice",
			"Trstín",
			"Trsťany",
			"Tŕnie",
			"Tuhár",
			"Tuhrina",
			"Tuchyňa",
			"Tulčík",
			"Tupá",
			"Turá",
			"Turany",
			"Turany nad Ondavou",
			"Turcovce",
			"Turček",
			"Turčianky",
			"Turčianska Štiavnička",
			"Turčianske Jaseno",
			"Turčianske Kľačany",
			"Turčianske Teplice",
			"Turčiansky Ďur",
			"Turčiansky Peter",
			"Turčok",
			"Turecká",
			"Tureň",
			"Turie",
			"Turík",
			"Turnianska Nová Ves",
			"Turňa nad Bodvou",
			"Turová",
			"Turzovka",
			"Tušice",
			"Tušická Nová Ves",
			"Tužina",
			"Tvarožná",
			"Tvrdomestice",
			"Tvrdošín",
			"Tvrdošovce",
			"Ťapešovo",
			"Ubľa",
			"Úbrež",
			"Udavské",
			"Udiča",
			"Údol",
			"Uhliská",
			"Úhorná",
			"Uhorská Ves",
			"Uhorské",
			"Uhrovec",
			"Uhrovské Podhradie",
			"Ulič",
			"Uličské Krivé",
			"Uloža",
			"Úľany nad Žitavou",
			"Unín",
			"Uňatín",
			"Urmince",
			"Utekáč",
			"Uzovce",
			"Uzovská Panica",
			"Uzovské Pekľany",
			"Uzovský Šalgov",
			"Vaďovce",
			"Vagrinec",
			"Váhovce",
			"Vajkovce",
			"Valaliky",
			"Valaská",
			"Valaská Belá",
			"Valaská Dubová",
			"Valaškovce (vojenský obvod)",
			"Valča",
			"Valentovce",
			"Valice",
			"Valkovce",
			"Vaľkovňa",
			"Vaniškovce",
			"Vápeník",
			"Varadka",
			"Varechovce",
			"Varhaňovce",
			"Varín",
			"Vasiľov",
			"Vavrečka",
			"Vavrinec",
			"Vavrišovo",
			"Važec",
			"Včelince",
			"Večelkov",
			"Vechec",
			"Velčice",
			"Veličná",
			"Velušovce",
			"Veľaty",
			"Veľká Čalomija",
			"Veľká Čausa",
			"Veľká Čierna",
			"Veľká Dolina",
			"Veľká Franková",
			"Veľká Hradná",
			"Veľká Ida",
			"Veľká Lehota",
			"Veľká Lesná",
			"Veľká Lodina",
			"Veľká Lomnica",
			"Veľká Lúka",
			"Veľká Mača",
			"Veľká nad Ipľom",
			"Veľká Paka",
			"Veľká Tŕňa",
			"Veľká Ves",
			"Veľká Ves nad Ipľom",
			"Veľké Bierovce",
			"Veľké Blahovo",
			"Veľké Borové",
			"Veľké Dravce",
			"Veľké Držkovce",
			"Veľké Dvorany",
			"Veľké Dvorníky",
			"Veľké Hoste",
			"Veľké Chlievany",
			"Veľké Chyndice",
			"Veľké Kapušany",
			"Veľké Kosihy",
			"Veľké Kostoľany",
			"Veľké Kozmálovce",
			"Veľké Kršteňany",
			"Veľké Leváre",
			"Veľké Lovce",
			"Veľké Ludince",
			"Veľké Orvište",
			"Veľké Ozorovce",
			"Veľké Pole",
			"Veľké Raškovce",
			"Veľké Revištia",
			"Veľké Ripňany",
			"Veľké Rovné",
			"Veľké Slemence",
			"Veľké Straciny",
			"Veľké Teriakovce",
			"Veľké Trakany",
			"Veľké Turovce",
			"Veľké Uherce",
			"Veľké Úľany",
			"Veľké Vozokany",
			"Veľké Zálužie",
			"Veľké Zlievce",
			"Veľkrop",
			"Veľký Biel",
			"Veľký Blh",
			"Veľký Cetín",
			"Veľký Čepčín",
			"Veľký Ďur",
			"Veľký Folkmar",
			"Veľký Grob",
			"Veľký Horeš",
			"Veľký Kamenec",
			"Veľký Klíž",
			"Veľký Krtíš",
			"Veľký Kýr",
			"Veľký Lapáš",
			"Veľký Lipník",
			"Veľký Lom",
			"Veľký Meder",
			"Veľký Slavkov",
			"Veľký Slivník",
			"Veľký Šariš",
			"Veľopolie",
			"Vernár",
			"Veselé",
			"Veterná Poruba",
			"Vidiná",
			"Vieska",
			"Vieska nad Blhom",
			"Vieska nad Žitavou",
			"Vígľaš",
			"Vígľašská Huta-Kalinka",
			"Vikartovce",
			"Vinica",
			"Viničky",
			"Viničné",
			"Vinné",
			"Vinodol",
			"Vinohrady nad Váhom",
			"Vinosady",
			"Virt",
			"Vislanka",
			"Vislava",
			"Visolaje",
			"Višňov",
			"Višňové",
			"Vištuk",
			"Vitanová",
			"Vítkovce",
			"Víťaz",
			"Víťazovce",
			"Vlača",
			"Vladiča",
			"Vlachovo",
			"Vlachy",
			"Vlčany",
			"Vlčkovce",
			"Vlkanová",
			"Vlkas",
			"Vlková",
			"Vlkovce",
			"Vlky",
			"Vlkyňa",
			"Voderady",
			"Vojany",
			"Vojčice",
			"Vojka",
			"Vojka nad Dunajom",
			"Vojkovce",
			"Vojnatina",
			"Vojňany",
			"Vojtovce",
			"Volica",
			"Volkovce",
			"Voľa",
			"Voznica",
			"Vozokany",
			"Vráble",
			"Vrádište",
			"Vrakúň",
			"Vranov nad Topľou",
			"Vrbnica",
			"Vrbov",
			"Vrbovce",
			"Vrbová nad Váhom",
			"Vrbové",
			"Vrbovka",
			"Vrchteplá",
			"Vrícko",
			"Vršatské Podhradie",
			"Vrútky",
			"Vtáčkovce",
			"Výborná",
			"Výčapy-Opatovce",
			"Vydrany",
			"Vydrná",
			"Vydrník",
			"Vyhne",
			"Východná",
			"Výrava",
			"Vysočany",
			"Vysoká",
			"Vysoká nad Kysucou",
			"Vysoká nad Uhom",
			"Vysoká pri Morave",
			"Vysoké Tatry",
			"Vyškovce",
			"Vyškovce nad Ipľom",
			"Vyšná Boca",
			"Vyšná Hutka",
			"Vyšná Jablonka",
			"Vyšná Jedľová",
			"Vyšná Kamenica",
			"Vyšná Myšľa",
			"Vyšná Olšava",
			"Vyšná Pisaná",
			"Vyšná Polianka",
			"Vyšná Rybnica",
			"Vyšná Sitnica",
			"Vyšná Slaná",
			"Vyšná Šebastová",
			"Vyšná Voľa",
			"Vyšné Ladičkovce",
			"Vyšné nad Hronom",
			"Vyšné Nemecké",
			"Vyšné Remety",
			"Vyšné Repaše",
			"Vyšné Ružbachy",
			"Vyšné Valice",
			"Vyšný Čaj",
			"Vyšný Hrabovec",
			"Vyšný Hrušov",
			"Vyšný Kazimír",
			"Vyšný Klátov",
			"Vyšný Komárnik",
			"Vyšný Kručov",
			"Vyšný Kubín",
			"Vyšný Medzev",
			"Vyšný Mirošov",
			"Vyšný Orlík",
			"Vyšný Skálnik",
			"Vyšný Slavkov",
			"Vyšný Tvarožec",
			"Vyšný Žipov",
			"Zábiedovo",
			"Záborie",
			"Záborské",
			"Zádiel",
			"Zádor",
			"Záhor",
			"Záhorce",
			"Záhorie (vojenský obvod)",
			"Záhorská Ves",
			"Záhradné",
			"Zacharovce",
			"Zákamenné",
			"Zákopčie",
			"Zalaba",
			"Zálesie",
			"Zalužice",
			"Zamarovce",
			"Zámutov",
			"Záriečie",
			"Záskalie",
			"Zatín",
			"Závada",
			"Závadka",
			"Závadka nad Hronom",
			"Zavar",
			"Závažná Poruba",
			"Závod",
			"Zázrivá",
			"Zbehňov",
			"Zbehy",
			"Zboj",
			"Zbojné",
			"Zborov",
			"Zborov nad Bystricou",
			"Zbrojníky",
			"Zbudská Belá",
			"Zbudské Dlhé",
			"Zbudza",
			"Zbyňov",
			"Zeleneč",
			"Zemianska Olča",
			"Zemianske Kostoľany",
			"Zemianske Podhradie",
			"Zemianske Sady",
			"Zemiansky Vrbovok",
			"Zemné",
			"Zemplín",
			"Zemplínska Nová Ves",
			"Zemplínska Široká",
			"Zemplínska Teplica",
			"Zemplínske Hámre",
			"Zemplínske Hradište",
			"Zemplínske Jastrabie",
			"Zemplínske Kopčany",
			"Zemplínsky Branč",
			"Zlatá Baňa",
			"Zlatá Idka",
			"Zlaté",
			"Zlaté Klasy",
			"Zlaté Moravce",
			"Zlatná na Ostrove",
			"Zlatník",
			"Zlatníky",
			"Zlatno",
			"Zliechov",
			"Zohor",
			"Zombor",
			"Zubák",
			"Zuberec",
			"Zubné",
			"Zubrohlava",
			"Zvolen",
			"Zvolenská Slatina",
			"Zvončín",
			"Žabokreky",
			"Žabokreky nad Nitrou",
			"Žakarovce",
			"Žakovce",
			"Žalobín",
			"Žarnov",
			"Žarnovica",
			"Žaškov",
			"Žbince",
			"Ždaňa",
			"Ždiar",
			"Žehňa",
			"Žehra",
			"Železná Breznica",
			"Železník",
			"Želiezovce",
			"Želmanovce",
			"Želovce",
			"Žemberovce",
			"Žemliare",
			"Žiar",
			"Žiar nad Hronom",
			"Žibritov",
			"Žihárec",
			"Žikava",
			"Žilina",
			"Žíp",
			"Žipov",
			"Žirany",
			"Žitavany",
			"Žitavce",
			"Žitná-Radiša",
			"Žlkovce",
			"Župčany",
			"Župkov"
		]
	});
}

const APIController = new WooptimaAPI({
	baseURL: baseURL,
	namespace: 'wp-json/es/forms/v1',
	headers: process.env.NODE_ENV === 'development'
		? {
			'Content-Type': 'application/json',
			'X-Wooptima-Nonce': authNonce ?? ''
		}
		: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': authNonce ?? ''
		},
	endpoints
});

export default APIController;